import React from "react";
import { Layout, Button } from "antd";
import { useHistory } from "react-router-dom";

const ConfirmEmailPage = () => {
  const history = useHistory();
  const backToHome = () => {
    let path = `/`;
    history.push(path);
  };
  return (
    <Layout>
      <Layout.Content>
        <div className="ConfirmEmailPage big-bottom-padding">
          <h1>Thanks for signing up</h1>
          <p className="lead">
            Check your mailbox to continue the sign up process and confirm your
            email.
          </p>
          <Button
            className="btn-bordered"
            onClick={backToHome}
            style={{ margin: "0px 5px", width: "200px" }}
            type="text"
          >
            GO TO HOME
          </Button>
        </div>
      </Layout.Content>
    </Layout>
  );
};

export default ConfirmEmailPage;
